export default "__VITE_ASSET__C2dktr$D__"